import React from 'react';
import {withTranslation} from 'react-i18next';
import {Field, Form as FinalForm} from 'react-final-form';
import {Button, Col, Form, Row} from 'reactstrap';
import PriceField from '../components/PriceField';
import LoaderButton from '../components/LoaderButton';
import ModalManager from '../components/modal/ModalManager';
import {join, map, isEqual, filter, forEach, without, includes} from 'lodash';
import {Separator} from '../components/common/CustomBootstrap';
import {baseTokenSymbol} from '../constants/configs';
import FieldError from '../components/FieldError';
import Select from 'react-select';
import {store} from "../AppRenderer";

class KycLevelForm extends React.Component {
  constructor(props) {
    super(props);
    this.kycItems = store.getState().app.kycItems;
  }

  createLevel = async values => {
    this.props.addLevel(values);
    ModalManager.close({
      isOpen: false
    });
  };

  updateLevel = async values => {
    this.props.editLevel(values);
    ModalManager.close({
      isOpen: false
    });
  }

  ReactSelectAdapter = ({input, ...rest}) => (
    <Select
      {...input}
      {...rest}
      isMulti
      placeholder={this.props.t('Select')}
    />
  );

  getDefaultKycLevel = () => {
    return (
      {
        items: [],
        fiat: {
          deposit: {
            max24h: null,
            max30d: null,
          },
          withdraw: {
            max24h: null,
            max30d: null,
          }
        },
        crypto: {
          deposit: {
            max24h: null,
            max30d: null,
          },
          withdraw: {
            max24h: null,
            max30d: null,
          }
        }
      }
    );
  }

  getItemsOptions = value => {
    const {t, policy, level} = this.props;
    const firstItem = {
      label: `${t('identityCardPic')} ${t('or')} ${t('passportPic')} ${t('or')} ${t('driverLicensePic')}`,
      value: ['identityCardPic', 'passportPic', 'driverLicensePic'],
    };
    const secondItem = {
      label: `${t('facePic')} ${t('or')} ${t('faceVideo')}`,
      value: ['facePic', 'faceVideo'],
    }
    const items = [
      firstItem,
      secondItem,
      ...map(
        filter(this.kycItems, item => !includes([...firstItem.value, ...secondItem.value], item.name)),
        item => ({label: t(item.name), value: [item.name]})
      ),
    ];

    return filter(items, item => {
      let isInclude = true;
      forEach([...without(policy.levels, level), {items: map(value, 'value')}], level => {
        forEach(level.items, b => {
          if (isEqual(b, item.value)) {
            isInclude = false;
            return false;
          }
        });
      });
      return isInclude;
    });
  };

  render() {
    const {t, level} = this.props;
    return(
      <FinalForm
        initialValues={level ?
          {...level,
            items: level.items.length ?
              level.items.map(item => ({
                label: join(map(item, t), ` ${t('or')} `),
                value: item,
              })) : []
          } : this.getDefaultKycLevel()
        }
        onSubmit={level ? this.updateLevel : this.createLevel}
        render={({handleSubmit, submitting, hasValidationErrors, values}) => {
          return (
            <Form onSubmit={handleSubmit}>
              <div className='text-info text-one font-weight-semibold mb-4'>
                {t('Fiat Limits')}
              </div>
              <Row>
                <Col>
                  <PriceField item={{
                    name: 'fiat.deposit.max_24h',
                    i18n: t('Deposit Max 24h'),
                    unit: t(baseTokenSymbol),
                  }}/>
                </Col>
                <Col>
                  <PriceField item={{
                    name: 'fiat.withdraw.max_24h',
                    i18n: t('Withdraw Max 24h'),
                    unit: t(baseTokenSymbol),
                  }}/>
                </Col>
              </Row>
              <Row>
                <Col>
                  <PriceField item={{
                    name: 'fiat.deposit.max_30d',
                    i18n: t('Deposit Max 30d'),
                    unit: t(baseTokenSymbol),
                  }}/>
                </Col>
                <Col>
                  <PriceField item={{
                    name: 'fiat.withdraw.max_30d',
                    i18n: t('Withdraw Max 30d'),
                    unit: t(baseTokenSymbol),
                  }}/>
                </Col>
              </Row>
              <Separator className='my-3'/>
              <div className='text-info text-one font-weight-semibold mb-4'>
                {t('Crypto Limits')}
              </div>
              <Row>
                <Col>
                  <PriceField item={{
                    name: 'crypto.deposit.max_24h',
                    i18n: t('Deposit Max 24h'),
                    unit: t(baseTokenSymbol),
                    disabled: true,
                  }}/>
                </Col>
                <Col>
                  <PriceField item={{
                    name: 'crypto.withdraw.max_24h',
                    i18n: t('Withdraw Max 24h'),
                    unit: t(baseTokenSymbol),
                  }}/>
                </Col>
              </Row>
              <Row>
                <Col>
                  <PriceField item={{
                    name: 'crypto.deposit.max_30d',
                    i18n: t('Deposit Max 30d'),
                    unit: t(baseTokenSymbol),
                    disabled: true,
                  }}/>
                </Col>
                <Col>
                  <PriceField item={{
                    name: 'crypto.withdraw.max_30d',
                    i18n: t('Withdraw Max 30d'),
                    unit: t(baseTokenSymbol),
                  }}/>
                </Col>
              </Row>
              <Separator className='my-3'/>
              {!!level && level.level !== 1 && <Row>
                <Col>
                  <span>{t('Documents')}</span>
                  <Field
                    name="items"
                    component={this.ReactSelectAdapter}
                    options={this.getItemsOptions(values.items)}
                    closeMenuOnSelect={false}
                  />
                  <FieldError name='items'/>
                </Col>
              </Row>}
              <Row style={{marginTop: 20}}>
                <Col>
                  <LoaderButton
                    color="success"
                    onClick={handleSubmit}
                    loading={submitting}
                    disabled={hasValidationErrors || submitting}
                    className="text-center"
                    style={{minWidth: '100px'}}>
                    {level ? t('Update') : t('Submit')}
                  </LoaderButton>
                  <Button
                    color="grey"
                    onClick={() =>{
                      ModalManager.close({
                        isOpen: false
                      });
                    }}
                    className="text-center mx-2"
                    style={{minWidth: '100px'}}>
                    {t('Close')}
                  </Button>
                </Col>
              </Row>
            </Form>
          );
        }}
      />
    );
  }
}

export default withTranslation()(KycLevelForm);
